import { render, staticRenderFns } from "./SanadatList.vue?vue&type=template&id=a14a73fc&scoped=true"
import script from "./SanadatList.vue?vue&type=script&lang=js"
export * from "./SanadatList.vue?vue&type=script&lang=js"
import style0 from "./SanadatList.vue?vue&type=style&index=0&id=a14a73fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14a73fc",
  null
  
)

export default component.exports